import http from '@axios'
import {getUserToken, getUserData} from "@/helpers/Utils";

const endpoint = `/event`;

const body = {
  "req": {
    "id": 123342523,
    "time": "2021-08-09T10:11:20+07:00",
    "src": "member-web",
    "op": "listPassEvent",
  },
  "data": {}
};

const listPassEvent = (data) => {
  const user = getUserData();
  body.req.op = 'listPassEvent';
  body.req.uid = user.id;
  body.req.uname = user.username;
  body.req.token = getUserToken();
  body.data = data;
  return http.post(endpoint, body);
};

const approvePass = (data) => {
  const user = getUserData();
  body.req.op = 'approvePass';
  body.req.uid = user.id;
  body.req.uname = user.username;
  body.req.token = getUserToken();
  body.data = data;
  return http.post(endpoint, body);
}
export { listPassEvent, approvePass }
